import React from 'react'

const RequestType = React.lazy(() => import('pages/RequestType/pages/RequestTypePage'));
const RequestTypeDetail = React.lazy(() => import('pages/RequestType/pages/RequestTypeDetail'));
const RequestTypeEdit = React.lazy(() => import('pages/RequestType/pages/RequestTypeEdit'));
const RequestTypeAdd = React.lazy(() => import('pages/RequestType/pages/RequestTypeAdd'));

const RequestTypeRoutes = [
    {
        path: '/request-type',
        exact: true,
        name: 'Danh sách yêu cầu bảo hành sửa chữa',
        function: 'RS_REQUESTTYPE_VIEW',
        component: RequestType,
    },
    {
        path: '/request-type/add',
        exact: true,
        name: 'Thêm mới',
        function: 'RS_REQUESTTYPE_ADD',
        component: RequestTypeAdd,
    },
    {
        path: '/request-type/edit/:id',
        exact: true,
        name: 'Chỉnh sửa',
        function: 'RS_REQUESTTYPE_EDIT',
        component: RequestTypeEdit,
    },
    {
        path: '/request-type/detail/:id',
        exact: true,
        name: 'Chi tiết',
        function: 'RS_REQUESTTYPE_VIEW',
        component: RequestTypeDetail,
    },
]

export default RequestTypeRoutes
